import '../style/spinner-CH9xP8M_.css'
import { defineComponent as l, computed as t, openBlock as c, createElementBlock as p, normalizeClass as a, normalizeStyle as m, createElementVNode as d } from "vue";
import { pxlize as u, colorize as h } from "x-utils";
const f = ["stroke-width"], k = /* @__PURE__ */ l({
  name: "e-spinner",
  __name: "spinner",
  props: {
    color: {},
    colorScheme: { default: "primary" },
    size: { default: 16 },
    strokeWidth: { default: 5 }
  },
  setup(n) {
    const o = n, s = t(() => ["e-spinner", `e-spinner--${o.colorScheme}`]), i = t(() => {
      const e = {};
      if (o.size) {
        const r = u(o.size);
        e.width = r, e.height = r;
      }
      return o.color && (e["--spinner-color"] = h(o.color)), e;
    });
    return (e, r) => (c(), p("svg", {
      class: a(s.value),
      style: m(i.value),
      viewBox: "0 0 50 50"
    }, [
      d("circle", {
        class: "path",
        cx: "25",
        cy: "25",
        r: "20",
        fill: "none",
        "stroke-width": e.strokeWidth
      }, null, 8, f)
    ], 6));
  }
});
export {
  k as default
};
//# sourceMappingURL=spinner.js.map
